 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		59: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		59: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors/pages/coupons/index/pages/customers/index/pages/employee-schedules/index/pages/employees/ind/6a14b6c7","1":"vendors/pages/customers/index/_id/index/pages/customers/index/create/pages/employees/index/_id/index/2aa51d97","2":"pages/customers/index/_id/index/pages/customers/index/create/pages/employees/index/_id/index/pages/e/2010de88","3":"vendors/pages/customers/index/pages/employees/index/pages/prices/index/pages/services/index","4":"commons/pages/employee-schedules/index2/pages/services/index/_id/index/pages/services/index/create","5":"pages/features/index/pages/index/pages/pricing","6":"pages/location-select/pages/locations/index/_id/edit/pages/locations/index/create","7":"vendors/pages/employee-schedules/index2/pages/services/index/_id/index/pages/services/index/create","8":"vendors/pages/location-select/pages/locations/index/_id/edit/pages/locations/index/create","9":"vendors/pages/pos/_customer/index/pages/reports/index/pages/timesheets/index","10":"pages/coupons/index/_id/index/pages/coupons/index/create","11":"pages/printers/index/_id/index/pages/printers/index/create","12":"pages/services/index/_id/index/pages/services/index/create","13":"pages/terminals","16":"pages/change-password","17":"pages/coupons/index","18":"pages/coupons/index/_id/index","19":"pages/coupons/index/create","20":"pages/customers/index","21":"pages/customers/index/_id/index","22":"pages/customers/index/create","23":"pages/employee-schedules/index","24":"pages/employee-schedules/index2","25":"pages/employees/index","26":"pages/employees/index/_id/index","27":"pages/employees/index/create","28":"pages/features/index","29":"pages/index","30":"pages/location-select","31":"pages/locations/index","32":"pages/locations/index/_id/edit","33":"pages/locations/index/_id/index","34":"pages/locations/index/create","35":"pages/login","36":"pages/pos/_customer/index","37":"pages/pos/_customer/pay","38":"pages/pos/_customer/pay/payment","39":"pages/pos/_customer/payments","40":"pages/pos/_customer/pickup","41":"pages/pos/_customer/tickets","42":"pages/pos/new","43":"pages/prices/index","44":"pages/prices/index/_id/index","45":"pages/prices/index/_type/create","46":"pages/pricing","47":"pages/printers/index","48":"pages/printers/index/_id/index","49":"pages/printers/index/create","50":"pages/reports/index","51":"pages/reports/index/_id/index","52":"pages/scanner/index","53":"pages/services/index","54":"pages/services/index/_id/index","55":"pages/services/index/create","56":"pages/subscription/index","57":"pages/subscription/index/create","58":"pages/timesheets/index","61":"vendors/pages/employee-schedules/index","62":"vendors/pages/location-select","63":"vendors/pages/locations/index/_id/index","64":"vendors/pages/pos/_customer/index","65":"vendors/pages/pos/_customer/tickets"}[chunkId]||chunkId) + "." + {"0":"28129a9","1":"20c93e8","2":"1192a02","3":"40d3268","4":"c7a890a","5":"2b0447a","6":"67ff034","7":"0f7e902","8":"5fd2b16","9":"19fe632","10":"765dc95","11":"a03d262","12":"e530571","13":"29faf8c","16":"f291ff3","17":"b9d0ff9","18":"071f129","19":"7b87280","20":"d80b69a","21":"73f61b4","22":"7d5e173","23":"9c5afec","24":"a536f05","25":"ddc51c1","26":"ecf0bf4","27":"fc7f643","28":"37cbd3e","29":"3bd909f","30":"cb5cd8b","31":"a098f4f","32":"81f1b95","33":"fe79743","34":"03bef00","35":"86b37a8","36":"fb607b5","37":"3d91b79","38":"18988b5","39":"e895c1a","40":"e6a9af7","41":"40f3ecd","42":"631d759","43":"f7f0b2f","44":"96f0a52","45":"975ea28","46":"06c52e4","47":"4cd5bfd","48":"233bc48","49":"3aa4a5a","50":"878f61b","51":"9b8b5fc","52":"793bb6b","53":"49bdcae","54":"5c68e20","55":"79166a2","56":"2cbaeeb","57":"f240d52","58":"1312cb2","61":"96c197c","62":"2c41f4e","63":"657e7b4","64":"c7041f9","65":"27cde68"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// extract-css-chunks-webpack-plugin CSS loading
 		var supportsPreload = (function() { try { return document.createElement("link").relList.supports("preload"); } catch(e) { return false; }}());
 		var linkExists = false
 		var cssChunks = {"2":1,"3":1,"5":1,"6":1,"12":1,"20":1,"24":1,"25":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"36":1,"43":1,"44":1,"45":1,"46":1,"50":1,"52":1,"53":1,"56":1,"58":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors/pages/coupons/index/pages/customers/index/pages/employee-schedules/index/pages/employees/ind/6a14b6c7","1":"vendors/pages/customers/index/_id/index/pages/customers/index/create/pages/employees/index/_id/index/2aa51d97","2":"pages/customers/index/_id/index/pages/customers/index/create/pages/employees/index/_id/index/pages/e/2010de88","3":"vendors/pages/customers/index/pages/employees/index/pages/prices/index/pages/services/index","4":"commons/pages/employee-schedules/index2/pages/services/index/_id/index/pages/services/index/create","5":"pages/features/index/pages/index/pages/pricing","6":"pages/location-select/pages/locations/index/_id/edit/pages/locations/index/create","7":"vendors/pages/employee-schedules/index2/pages/services/index/_id/index/pages/services/index/create","8":"vendors/pages/location-select/pages/locations/index/_id/edit/pages/locations/index/create","9":"vendors/pages/pos/_customer/index/pages/reports/index/pages/timesheets/index","10":"pages/coupons/index/_id/index/pages/coupons/index/create","11":"pages/printers/index/_id/index/pages/printers/index/create","12":"pages/services/index/_id/index/pages/services/index/create","13":"pages/terminals","16":"pages/change-password","17":"pages/coupons/index","18":"pages/coupons/index/_id/index","19":"pages/coupons/index/create","20":"pages/customers/index","21":"pages/customers/index/_id/index","22":"pages/customers/index/create","23":"pages/employee-schedules/index","24":"pages/employee-schedules/index2","25":"pages/employees/index","26":"pages/employees/index/_id/index","27":"pages/employees/index/create","28":"pages/features/index","29":"pages/index","30":"pages/location-select","31":"pages/locations/index","32":"pages/locations/index/_id/edit","33":"pages/locations/index/_id/index","34":"pages/locations/index/create","35":"pages/login","36":"pages/pos/_customer/index","37":"pages/pos/_customer/pay","38":"pages/pos/_customer/pay/payment","39":"pages/pos/_customer/payments","40":"pages/pos/_customer/pickup","41":"pages/pos/_customer/tickets","42":"pages/pos/new","43":"pages/prices/index","44":"pages/prices/index/_id/index","45":"pages/prices/index/_type/create","46":"pages/pricing","47":"pages/printers/index","48":"pages/printers/index/_id/index","49":"pages/printers/index/create","50":"pages/reports/index","51":"pages/reports/index/_id/index","52":"pages/scanner/index","53":"pages/services/index","54":"pages/services/index/_id/index","55":"pages/services/index/create","56":"pages/subscription/index","57":"pages/subscription/index/create","58":"pages/timesheets/index","61":"vendors/pages/employee-schedules/index","62":"vendors/pages/location-select","63":"vendors/pages/locations/index/_id/index","64":"vendors/pages/pos/_customer/index","65":"vendors/pages/pos/_customer/tickets"}[chunkId]||chunkId) + ".css/" + {"0":"31d6cfe","1":"31d6cfe","2":"0e43387","3":"9b562b1","4":"31d6cfe","5":"60ceec2","6":"6afbcbc","7":"31d6cfe","8":"31d6cfe","9":"31d6cfe","10":"31d6cfe","11":"31d6cfe","12":"e9c57a5","13":"31d6cfe","16":"31d6cfe","17":"31d6cfe","18":"31d6cfe","19":"31d6cfe","20":"ed8b99b","21":"31d6cfe","22":"31d6cfe","23":"31d6cfe","24":"863a070","25":"4ed8ab3","26":"31d6cfe","27":"31d6cfe","28":"0984e06","29":"331b685","30":"343bc78","31":"65c39cc","32":"56e4562","33":"ca4275d","34":"56e4562","35":"31d6cfe","36":"5e46d48","37":"31d6cfe","38":"31d6cfe","39":"31d6cfe","40":"31d6cfe","41":"31d6cfe","42":"31d6cfe","43":"ed8b99b","44":"5d04d31","45":"5d04d31","46":"7786fc3","47":"31d6cfe","48":"31d6cfe","49":"31d6cfe","50":"fedd0c3","51":"31d6cfe","52":"922d795","53":"ed8b99b","54":"31d6cfe","55":"31d6cfe","56":"dbf523f","57":"31d6cfe","58":"a4daa17","61":"31d6cfe","62":"31d6cfe","63":"31d6cfe","64":"31d6cfe","65":"31d6cfe"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if((tag.rel === "stylesheet" || tag.rel === "preload") && (dataHref === href || dataHref === fullhref)) {
 						linkExists = true
 						return resolve();
 					}
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = supportsPreload ? "preload": "stylesheet";
 				supportsPreload ? linkTag.as = "style" : linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0]; head.appendChild(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 				if(!linkExists && supportsPreload) {
 					var execLinkTag = document.createElement("link");
 					execLinkTag.href =  __webpack_require__.p + "" + ({"0":"vendors/pages/coupons/index/pages/customers/index/pages/employee-schedules/index/pages/employees/ind/6a14b6c7","1":"vendors/pages/customers/index/_id/index/pages/customers/index/create/pages/employees/index/_id/index/2aa51d97","2":"pages/customers/index/_id/index/pages/customers/index/create/pages/employees/index/_id/index/pages/e/2010de88","3":"vendors/pages/customers/index/pages/employees/index/pages/prices/index/pages/services/index","4":"commons/pages/employee-schedules/index2/pages/services/index/_id/index/pages/services/index/create","5":"pages/features/index/pages/index/pages/pricing","6":"pages/location-select/pages/locations/index/_id/edit/pages/locations/index/create","7":"vendors/pages/employee-schedules/index2/pages/services/index/_id/index/pages/services/index/create","8":"vendors/pages/location-select/pages/locations/index/_id/edit/pages/locations/index/create","9":"vendors/pages/pos/_customer/index/pages/reports/index/pages/timesheets/index","10":"pages/coupons/index/_id/index/pages/coupons/index/create","11":"pages/printers/index/_id/index/pages/printers/index/create","12":"pages/services/index/_id/index/pages/services/index/create","13":"pages/terminals","16":"pages/change-password","17":"pages/coupons/index","18":"pages/coupons/index/_id/index","19":"pages/coupons/index/create","20":"pages/customers/index","21":"pages/customers/index/_id/index","22":"pages/customers/index/create","23":"pages/employee-schedules/index","24":"pages/employee-schedules/index2","25":"pages/employees/index","26":"pages/employees/index/_id/index","27":"pages/employees/index/create","28":"pages/features/index","29":"pages/index","30":"pages/location-select","31":"pages/locations/index","32":"pages/locations/index/_id/edit","33":"pages/locations/index/_id/index","34":"pages/locations/index/create","35":"pages/login","36":"pages/pos/_customer/index","37":"pages/pos/_customer/pay","38":"pages/pos/_customer/pay/payment","39":"pages/pos/_customer/payments","40":"pages/pos/_customer/pickup","41":"pages/pos/_customer/tickets","42":"pages/pos/new","43":"pages/prices/index","44":"pages/prices/index/_id/index","45":"pages/prices/index/_type/create","46":"pages/pricing","47":"pages/printers/index","48":"pages/printers/index/_id/index","49":"pages/printers/index/create","50":"pages/reports/index","51":"pages/reports/index/_id/index","52":"pages/scanner/index","53":"pages/services/index","54":"pages/services/index/_id/index","55":"pages/services/index/create","56":"pages/subscription/index","57":"pages/subscription/index/create","58":"pages/timesheets/index","61":"vendors/pages/employee-schedules/index","62":"vendors/pages/location-select","63":"vendors/pages/locations/index/_id/index","64":"vendors/pages/pos/_customer/index","65":"vendors/pages/pos/_customer/tickets"}[chunkId]||chunkId) + ".css/" + {"0":"31d6cfe","1":"31d6cfe","2":"0e43387","3":"9b562b1","4":"31d6cfe","5":"60ceec2","6":"6afbcbc","7":"31d6cfe","8":"31d6cfe","9":"31d6cfe","10":"31d6cfe","11":"31d6cfe","12":"e9c57a5","13":"31d6cfe","16":"31d6cfe","17":"31d6cfe","18":"31d6cfe","19":"31d6cfe","20":"ed8b99b","21":"31d6cfe","22":"31d6cfe","23":"31d6cfe","24":"863a070","25":"4ed8ab3","26":"31d6cfe","27":"31d6cfe","28":"0984e06","29":"331b685","30":"343bc78","31":"65c39cc","32":"56e4562","33":"ca4275d","34":"56e4562","35":"31d6cfe","36":"5e46d48","37":"31d6cfe","38":"31d6cfe","39":"31d6cfe","40":"31d6cfe","41":"31d6cfe","42":"31d6cfe","43":"ed8b99b","44":"5d04d31","45":"5d04d31","46":"7786fc3","47":"31d6cfe","48":"31d6cfe","49":"31d6cfe","50":"fedd0c3","51":"31d6cfe","52":"922d795","53":"ed8b99b","54":"31d6cfe","55":"31d6cfe","56":"dbf523f","57":"31d6cfe","58":"a4daa17","61":"31d6cfe","62":"31d6cfe","63":"31d6cfe","64":"31d6cfe","65":"31d6cfe"}[chunkId] + ".css";
 					execLinkTag.rel = "stylesheet";
 					execLinkTag.type = "text/css";
 					document.body.appendChild(execLinkTag);
 				}
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/_nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
